export const VR = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="8" fill="#ED9913" fillOpacity="0.05" />
      <rect
        x="0.666477"
        y="0.666477"
        width="54.667"
        height="54.667"
        rx="7.33352"
        stroke="#ED9913"
        strokeOpacity="0.15"
        strokeWidth="1.33295"
      />
      <path
        d="M28 30.5C26.1818 30.5 26.1818 33 23.6364 33C21.0909 33 20 30.5 20 28C20 23.4167 24.3636 23 28 23C31.6364 23 36 23.4167 36 28C36 30.4463 34.9091 33 32.3636 33C29.8182 33 29.8182 30.5 28 30.5Z"
        stroke="#ED9913"
        strokeWidth="1.87"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
